<template>
    <div class="flex-center">
<!--        <v-btn-->
<!--                text min-width="0"-->
<!--                :color="$i18n.locale === 'th' ? '#FD5246':''"-->
<!--                @click="onSetLang('th')"-->
<!--        >-->
<!--            TH-->
<!--        </v-btn>-->
<!--        <div style="height: 25px">-->
<!--            <v-divider vertical style="border: solid 1.25px rgba(0,0,0,.3);"></v-divider>-->
<!--        </div>-->
<!--        <v-btn-->
<!--                text min-width="0"-->
<!--                :color="$i18n.locale === 'en' ? '#FD5246':''"-->
<!--                @click="onSetLang('en')"-->
<!--        >-->
<!--            EN-->
<!--        </v-btn>-->

        <v-btn
                v-if="switchs"
                outlined
                text min-width="0"
                @click="onSetLangs"
        >
            TH
        </v-btn>
        <v-btn
                v-if="!switchs"
                outlined
                text min-width="0"
                @click="onSetLangs"
        >
            EN
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "LangSwitcher",
        data: () => ({
            switchs: true,
        }),
        methods: {
            onSetLang(lang) {
                this.$i18n.locale = lang;
            },
            onSetLangs() {
                this.switchs = !this.switchs;
                if (this.switchs) {
                    this.$i18n.locale = 'th';
                    this.$store.dispatch('Common/setLanguage',this.$i18n.locale);
                } else {
                    this.$i18n.locale = 'en';
                    this.$store.dispatch('Common/setLanguage',this.$i18n.locale);
                }
            }
        }
    }
</script>

<style scoped>

</style>
